<div
  class="flex items-center justify-between rounded-xl border border-secondary-300
    bg-secondary-50 px-4 py-2.5">
  <div class="flex items-center gap-3">
    <div class="text-secondary-700">
      <ng-icon name="phosphorCursorClick" size="18px" />
    </div>
    <div>
      <p class="text-sm font-bold text-secondary-700">Selection Mode</p>
      <p>
        Click on the widgets you want to include in your report. Choose the
        format (PDF or PNG) when ready.
      </p>
    </div>
  </div>

  <div class="flex items-center gap-3">
    <span
      class="whitespace-nowrap rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold
        text-slate-600">
      {{ selectedCount() }} selected
    </span>
    <p-button
      variant="outlined"
      class="whitespace-nowrap rounded-md border border-zinc-800 text-sm font-medium"
      (click)="selectAll.emit()"
      [injectAttribute]="[
        {
          CSSPath: 'button',
          attribute: 'analytics-label',
          value:
            { element: 'button', action: 'export_select_all_clicked' }
            | analyticsLabelValue,
        },
      ]">
      Select all
    </p-button>
    <p-button
      variant="outlined"
      class="whitespace-nowrap rounded-md border border-zinc-800 text-sm font-medium"
      (click)="clear.emit()">
      Clear
    </p-button>
    <p-button
      [disabled]="selectedCount() === 0"
      (click)="continueClick.emit()"
      class="flex items-center gap-2">
      Continue
      <ng-icon name="phosphorArrowRight" class="align-middle" />
    </p-button>
  </div>
</div>
